// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_conversationContext_AvailableConversationContext_context(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "BuyerNeedV5",
    "DevelopmentProject",
    "DevelopmentProjectSampleUnit",
    "ForSalePropertyV5",
    "MessageBroadcast",
    "RentalNeedV5",
    "RentalPropertyV5"
  ]);
}

function unwrap_fragment_conversationContext(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "AvailableConversationContext",
    "RemovedConversationContext"
  ]);
}

let fragmentConverter = {"__root":{"conversationContext_AvailableConversationContext_context_RentalPropertyV5_propertyLocation":{"f":""},"conversationContext_AvailableConversationContext_context_ForSalePropertyV5_propertyLocation":{"f":""},"conversationContext_AvailableConversationContext_context":{"u":"fragment_conversationContext_AvailableConversationContext_context"},"conversationContext":{"u":"fragment_conversationContext"}}};

let fragmentConverterMap = {
  fragment_conversationContext_AvailableConversationContext_context: unwrap_fragment_conversationContext_AvailableConversationContext_context,
  fragment_conversationContext: unwrap_fragment_conversationContext
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function conversationContextTypeV5_decode($$enum) {
  if ($$enum === "BROADCAST_MESSAGE" || $$enum === "RENTAL_PROPERTY" || $$enum === "BUYER_NEED" || $$enum === "RENTAL_NEED" || $$enum === "DEVELOPMENT_PROJECT" || $$enum === "FOR_SALE_PROPERTY" || $$enum === "DEVELOPMENT_SAMPLE_UNIT") {
    return $$enum;
  }
}

let conversationContextTypeV5_fromString = conversationContextTypeV5_decode;

function developmentProjectUnitType_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY") {
    return $$enum;
  }
}

let developmentProjectUnitType_fromString = developmentProjectUnitType_decode;

function messageBroadcasStatus_decode($$enum) {
  if ($$enum === "DELETED" || $$enum === "RESUMABLE_DRAFT" || $$enum === "DRAFT" || $$enum === "PUBLISHED" || $$enum === "EXPIRED") {
    return $$enum;
  }
}

let messageBroadcasStatus_fromString = messageBroadcasStatus_decode;

let Utils = {
  conversationContextTypeV5_decode: conversationContextTypeV5_decode,
  conversationContextTypeV5_fromString: conversationContextTypeV5_fromString,
  developmentProjectUnitType_decode: developmentProjectUnitType_decode,
  developmentProjectUnitType_fromString: developmentProjectUnitType_fromString,
  messageBroadcasStatus_decode: messageBroadcasStatus_decode,
  messageBroadcasStatus_fromString: messageBroadcasStatus_fromString
};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  {
    "kind": "RequiredField",
    "field": {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "format",
          "value": "SHORT"
        }
      ],
      "kind": "ScalarField",
      "name": "formatted",
      "storageKey": "formatted(format:\"SHORT\")"
    },
    "action": "NONE"
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "headline",
    "storageKey": null
  },
  {
    "kind": "RequiredField",
    "field": {
      "alias": null,
      "args": null,
      "concreteType": "PriceRange",
      "kind": "LinkedField",
      "name": "priceRange",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "concreteType": "Price",
            "kind": "LinkedField",
            "name": "maxPrice",
            "plural": false,
            "selections": (v1/*: any*/),
            "storageKey": null
          },
          "action": "NONE"
        },
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "concreteType": "Price",
            "kind": "LinkedField",
            "name": "minPrice",
            "plural": false,
            "selections": (v1/*: any*/),
            "storageKey": null
          },
          "action": "NONE"
        }
      ],
      "storageKey": null
    },
    "action": "NONE"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "PropertyImageConnection",
  "kind": "LinkedField",
  "name": "images",
  "plural": false,
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": "PropertyImageEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "alias": null,
              "args": null,
              "concreteType": "ImageAttachment",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "crop",
                        "value": true
                      },
                      {
                        "kind": "Literal",
                        "name": "embed",
                        "value": true
                      },
                      {
                        "kind": "Literal",
                        "name": "height",
                        "value": 324
                      },
                      {
                        "kind": "Variable",
                        "name": "ratio",
                        "variableName": "__relay_internal__pv__DevicePixelRatio"
                      },
                      {
                        "kind": "Literal",
                        "name": "width",
                        "value": 324
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  "action": "NONE"
                }
              ],
              "storageKey": null
            },
            "action": "NONE"
          }
        ],
        "storageKey": null
      },
      "action": "NONE"
    }
  ],
  "storageKey": null
},
v4 = {
  "kind": "RequiredField",
  "field": {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "propertyLocation",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ConversationsListItemContextLocationDisplay_location"
      }
    ],
    "storageKey": null
  },
  "action": "NONE"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = [
  (v5/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__DevicePixelRatio"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConversationsListItemContext_conversation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "conversationContext",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entityType",
                "storageKey": null
              },
              "action": "NONE"
            }
          ],
          "type": "RemovedConversationContext",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "context",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v2/*: any*/),
                  "type": "BuyerNeedV5",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v3/*: any*/),
                    (v4/*: any*/)
                  ],
                  "type": "ForSalePropertyV5",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "alias": null,
                        "args": null,
                        "concreteType": "CategoryV5",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "RequiredField",
                            "field": (v5/*: any*/),
                            "action": "NONE"
                          }
                        ],
                        "storageKey": null
                      },
                      "action": "NONE"
                    },
                    {
                      "kind": "RequiredField",
                      "field": {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "subject",
                        "storageKey": null
                      },
                      "action": "NONE"
                    },
                    {
                      "alias": "messageBroadcastStatus",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    }
                  ],
                  "type": "MessageBroadcast",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v2/*: any*/),
                  "type": "RentalNeedV5",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v4/*: any*/),
                    (v3/*: any*/)
                  ],
                  "type": "RentalPropertyV5",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v6/*: any*/),
                  "type": "DevelopmentProject",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v5/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "unitType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DevelopmentProject",
                      "kind": "LinkedField",
                      "name": "development",
                      "plural": false,
                      "selections": (v6/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "type": "DevelopmentProjectSampleUnit",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "AvailableConversationContext",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ConversationV5",
  "abstractKey": null
};
})());

let wrap_fragment_conversationContext_AvailableConversationContext_context = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_conversationContext = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_conversationContext_AvailableConversationContext_context = unwrap_fragment_conversationContext_AvailableConversationContext_context;
exports.wrap_fragment_conversationContext_AvailableConversationContext_context = wrap_fragment_conversationContext_AvailableConversationContext_context;
exports.unwrap_fragment_conversationContext = unwrap_fragment_conversationContext;
exports.wrap_fragment_conversationContext = wrap_fragment_conversationContext;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
